import {
  ThemeProvider,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";

import AppMenuItemComponent from "./AppMenuItemComponent";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";
import React from "react";
import { Typography } from "@material-ui/core";
import { colours, theme } from "../constants/theme";

export const AppMenuItemPropTypesI = {
  active: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  link: PropTypes.string,
  icon: PropTypes.any,
  items: PropTypes.array,
  isSecondLevel: PropTypes.bool.isRequired,
};

type AppMenuItemPropTypes = PropTypes.InferProps<typeof AppMenuItemPropTypesI>;
type AppMenuItemPropsWithoutItems = Omit<AppMenuItemPropTypes, "items">;

export type AppMenuItemProps = AppMenuItemPropsWithoutItems & {
  items?: AppMenuItemProps[];
};

export type makeStyleProps = {
  isSecondLevel: boolean;
  active: boolean;
};

const AppMenuItem: React.FC<AppMenuItemProps> = (props) => {
  const { active, name, link, icon, isSecondLevel = false } = props;
  const classes = useStyles({ active, isSecondLevel });
  const [open, setOpen] = React.useState(false);
  function handleClick() {
    setOpen(!open);
  }
  const IconComponent = icon;

  const MenuItemRoot = (
    <ThemeProvider theme={theme}>
      <AppMenuItemComponent
        className={classes.menuItem}
        style={{
          background: isSecondLevel ? "rgba(0, 0, 0, 0.08)" : undefined,
        }}
        link={link}
        onClick={handleClick}
      >
        {!!icon && (
          <ListItemIcon>
            <IconComponent className={classes.menuItemIcon} />
          </ListItemIcon>
        )}
        <ListItemText inset={!icon}>
          <Typography
            variant="body2"
            component="span"
            className={classes.menuItemText}
          >
            {name}
          </Typography>
        </ListItemText>
      </AppMenuItemComponent>
    </ThemeProvider>
  );

  return <>{MenuItemRoot}</>;
};

const useStyles = makeStyles(
  createStyles({
    // TODO
    // @ts-ignore
    menuItem: ({ isSecondLevel }: makeStyleProps) => ({
      height: "41px",
      marginTop: "4px",
      marginBottom: "4px",
      paddingLeft: "12px",
      paddingRight: "12px",
      borderRadius: "8px",
      color: colours.lightEmphasis,
      background: isSecondLevel && colours.light12,
      // Selected - First level
      "&.active": {
        color: theme.palette.primary.main,
        background: theme.palette.primary[32],
      },
      // Hover
      "&:hover, &.active:hover": {
        background: theme.palette.primary[16],
      },
    }),
    menuListItemText: {
      height: "20px",
      display: "flex",
      alignItems: "stretch",
    },
    menuItemText: {
      fontWeight: 600,
      letterSpacing: ".3px",
    },
    menuItemIcon: ({ active }: makeStyleProps) => ({
      color: active
        ? theme.palette.primary.main
        : colours.lightEmphasis
    }),
  })
);
export default AppMenuItem;
